<template>
  <div v-if="this.$store.state.access === true" class="noteResult">
    <h1>
      {{classTitle}}
      <small>{{coreGroupName}}</small>
    </h1>
    <div class="noteBoxHolder" v-if="memberDisplay !== false">
      <div
        :class="(memberDisplay.personID === member.personID)?'noteBox active':'noteBox'"
        v-for="member in getCoreGroupPeople"
        :key="member.personID"
        @click="setMemberData(member)"
      >
        <h2>{{member.firstName}} {{member.lastName}}</h2>
        <div class="tagHolder">
          <span style="font-size: 14px">{{member.email}}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <BadLink />
  </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "PeopleList",
  methods: {
    ...mapActions([
      "getAuthToken",
      "fetchEvents",
      "fetchMeetings",
      "fetchEvent",
      "fetchCoreGroup",
      "fetchClass",
      "fetchCoreGroupPeople",
      "fetchLeaderDetails",
    ]),
    ...mapMutations([
      "setEventDisplay",
      "setMemberDisplay",
      "setMeetings",
      "setShowEventDetails",
      "setShowMemberDetails",
    ]),
    setMemberData(member) {
      this.setShowMemberDetails(true);
      this.setMemberDisplay(member);
    },
  },
  computed: {
    ...mapGetters([
      "getCoreGroupPeople",
      "allEvents",
      "eventDisplay",
      "memberDisplay",
      "coreGroupName",
      "classTitle",
      "leaderDetails",
    ]),
  },
  beforeMount() {
    if (
      this.$store.state.token !== "" &&
      this.$store.state.personId > 0 &&
      this.$store.state.userId > 0 &&
      this.$store.state.roleId > 0 &&
      this.$store.state.classSessionId > 0 &&
      this.$store.state.coreGroupId > 0
    ) {
      if (this.getCoreGroupPeople === null) {
        this.fetchCoreGroup(this.$store.state.coreGroupId);
      }
      this.fetchCoreGroupPeople(this.$store.state.coreGroupId).then(
        (result) => {
          this.fetchClass(this.$store.state.classId);
          this.fetchCoreGroup(this.$store.state.coreGroupId);
          this.fetchLeaderDetails(this.$store.state.personId);
        }
      );
    } else {
      let encryptedData = this.$route.query.data;
      if (encryptedData) {
        this.decryptData(encryptedData).then((response) => {
          this.getAuthToken().then((result) => {
            if (result !== "") {
              if (
                this.$store.state.personId > 0 &&
                this.$store.state.userId > 0 &&
                this.$store.state.roleId > 0 &&
                this.$store.state.classSessionId > 0 &&
                this.$store.state.coreGroupId > 0
              ) {
                this.getAuthToken().then((result) => {
                  if (result !== "") {
                    if (this.getCoreGroupPeople === null) {
                      this.fetchCoreGroup(this.$store.state.coreGroupId);
                    }
                    this.fetchCoreGroupPeople(
                      this.$store.state.coreGroupId
                    ).then((result) => {
                      this.fetchClass(this.$store.state.classId);
                      this.fetchCoreGroup(this.$store.state.coreGroupId);
                      this.fetchLeaderDetails(this.$store.state.personId);
                    });
                  }
                });
              }
            }
          });
        });
      }
      else{
        this.$store.commit('setForbiddenAccess');
      }
    }
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-noteResult.scss">
</style>